import { render, staticRenderFns } from "./shanghai-print.vue?vue&type=template&id=826b7872&scoped=true&"
import script from "./shanghai-print.vue?vue&type=script&lang=ts&"
export * from "./shanghai-print.vue?vue&type=script&lang=ts&"
import style0 from "./shanghai-print.vue?vue&type=style&index=0&id=826b7872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826b7872",
  null
  
)

export default component.exports